import { render, staticRenderFns } from "./AdministratorDashboard.vue?vue&type=template&id=00ba48ba&"
import script from "./administrator-dashboard.ts?vue&type=script&lang=ts&"
export * from "./administrator-dashboard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports